export type PageMeta = { total: number; page: number; page_size: number; has_next: boolean }

export type AdminUser = {
  id: string
  name: string
  email?: string | null
  phone?: string | null
  account_type: string
  country?: string | null
  city?: string | null
  created_at?: string | null
  identity_status: string
  is_blocked: boolean
  is_verified: boolean
  rating_avg: number
  rating_count: number
  completed_orders_count: number
  accepted_orders_count: number
  staff_role?: string | null
  role: string
  avatar_url?: string | null
  bio?: string | null
  headline?: string | null
  passport_main_url?: string | null
  passport_reg_url?: string | null
  identity_reject_reason?: string | null
  last_active_at?: string | null
}

export type Dashboard = {
  users_total: number
  users_today: number
  users_7d: number
  users_active: number
  orders_published: number
  orders_today: number
  orders_in_progress: number
  orders_completed: number
  deals_active: number
  deals_completed: number
  deals_disputed: number
  payments_sum: number
  identity_pending: number
  identity_approved: number
  identity_rejected: number
  attention: { key: string; label: string; count: number; href: string }[]
  registrations_by_day: { date: string; count: number }[]
  orders_by_day: { date: string; count: number }[]
}

export type AdminOrder = {
  id: string
  title: string
  status: string
  moderation_status: string
  budget_min?: number | null
  budget_max?: number | null
  currency: string
  author_id: string
  author_name?: string | null
  proposals_count: number
  created_at?: string | null
}

export type AdminDeal = {
  id: string
  public_number: string
  status: string
  amount: number | string
  currency: string
  customer_name?: string | null
  executor_name?: string | null
  order_title?: string | null
  created_at?: string | null
}

export type AdminProposal = {
  id: string
  order_id: string
  status: string
  price: number | string
  currency: string
  order_title?: string | null
  executor_name?: string | null
  created_at?: string | null
}

export type AuditItem = {
  id: string
  actor_name?: string | null
  action: string
  entity_type?: string | null
  entity_id?: string | null
  meta: Record<string, unknown>
  created_at?: string | null
}

export function money(v: number | string | null | undefined, currency = 'RUB') {
  const n = typeof v === 'string' ? Number(v) : (v ?? 0)
  return new Intl.NumberFormat('ru-RU', { style: 'currency', currency, maximumFractionDigits: 0 }).format(n)
}

export function fmtDate(v?: string | null) {
  if (!v) return '—'
  return new Date(v).toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'short' })
}
